export const getRelativeTime = (dateString: string) => {
  const now = new Date();
  const reportDate = new Date(dateString);
  const diffInMs = now.getTime() - reportDate.getTime();
  const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
  const diffInHours = Math.floor(diffInMinutes / 60);
  const diffInDays = Math.floor(diffInHours / 24);

  if (diffInMinutes < 1) {
    return 'mis à jour à l\'instant';
  } else if (diffInMinutes < 60) {
    return `mis à jour il y a ${diffInMinutes} min`;
  } else if (diffInHours < 24) {
    return `mis à jour il y a ${diffInHours}h`;
  } else if (diffInDays < 7) {
    return `mis à jour il y a ${diffInDays}j`;
  } else {
    return `mis à jour le ${reportDate.toLocaleDateString('fr-FR')}`;
  }
};